module.exports = __webpack_public_path__ + "static/media/Barmag FK6 1000 Drive.4b91cff4.jpg";